import { render, staticRenderFns } from "./UnBindWithhold.vue?vue&type=template&id=27b9e999&scoped=true"
import script from "./UnBindWithhold.vue?vue&type=script&setup=true&lang=js"
export * from "./UnBindWithhold.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UnBindWithhold.vue?vue&type=style&index=0&id=27b9e999&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b9e999",
  null
  
)

export default component.exports